import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-coral-500)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path d="M20 12H12V20H20V12Z" fill={textColor} />
    <path d="M12 4H4V12H12V4Z" fill={textColor} />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path d="M24.96 16H16V24.96H24.96V16Z" fill={textColor} />
    <path d="M16 7.04004H7.04004V16H16V7.04004Z" fill={textColor} />
  </>
);

export const RatingIcon = createSlideIcon(Icon24x24, Icon32x32);
